// extracted by mini-css-extract-plugin
export default {"cardProgress":"styles_cardProgress__YWzSQ","spinnerWrapper":"styles_spinnerWrapper__v-0e8"};